// attachmentUtils.js

const isNodeReferenceAttachment = (attachment) => {
  const typeValue = String(attachment?.type || '').trim().toLowerCase();
  if (typeValue === 'node_ref') return true;
  return Boolean(String(attachment?.nodeKey || '').trim());
};

const getAttachmentKey = (attachment, fallback) => {
  const explicitKey = String(attachment?.key || '').trim();
  if (explicitKey) return explicitKey;

  const urlKey = String(attachment?.url || '').trim();
  if (urlKey) return urlKey;

  const nodeKey = String(attachment?.nodeKey || '').trim();
  if (nodeKey) return nodeKey;

  return fallback;
};

export const resolveAttachmentViewModel = ({ attachment, index, attachmentNodesByKey }) => {
  const fallbackKey = `attachment-${index}`;
  const baseKey = getAttachmentKey(attachment, fallbackKey);
  const attachmentType = String(attachment?.type || '').trim().toLowerCase();

  if (attachmentType === 'image' && (attachment?.url || attachment?.path)) {
    return {
      key: baseKey,
      kind: 'image',
      // Download-token URL works for <img src>; path is retained for signed-URL migration.
      url: attachment.url || attachment.path,
      alt: attachment.name || 'Message attachment',
      storagePath: attachment.path || null,
    };
  }

  if (!isNodeReferenceAttachment(attachment)) {
    return null;
  }

  const nodeKey = String(attachment?.nodeKey || '').trim();
  const nodeState = nodeKey ? attachmentNodesByKey?.[nodeKey] : null;
  const hydratedNode = nodeState?.node || null;
  const nodeTypeKey = String(hydratedNode?.type || attachment?.nodeType || 'NODE').trim() || 'NODE';
  const nodeTitle = String(hydratedNode?.title || attachment?.title || '').trim();
  const status = nodeKey ? (nodeState?.status || 'loading') : 'unavailable';
  const seedNode = {
    key: nodeKey,
    title: nodeTitle || 'Untitled',
    type: nodeTypeKey,
  };
  const nodeForCard = hydratedNode?.key ? hydratedNode : seedNode;
  const normalizedNodeType = String(nodeTypeKey || '').toUpperCase();

  if (status === 'unavailable' || !nodeKey) {
    return {
      key: `${baseKey}-unavailable`,
      kind: 'unavailable',
    };
  }

  if (status === 'loading') {
    return {
      key: `${baseKey}-loading`,
      kind: 'loading',
      title: nodeTitle || 'Loading item...',
    };
  }

  if (normalizedNodeType === 'PHOTO') {
    return {
      key: `${baseKey}-photo`,
      kind: 'photo',
      node: nodeForCard,
    };
  }

  if (normalizedNodeType === 'VIDEO') {
    return {
      key: `${baseKey}-video`,
      kind: 'video',
      node: nodeForCard,
    };
  }

  return {
    key: `${baseKey}-node`,
    kind: 'node',
    node: nodeForCard,
  };
};
